import { useEffect, useContext, useState } from "react";
import { Col, Row } from "reactstrap";
import styles from "./prupose-desktop.module.css";
import Text from "../../atoms/text/text";
import { useTranslation } from "react-i18next";
import SvgLoader from "../../atoms/svg-loader/svg-loader";
import { GlobalContext } from "../../../context/global-context-provider";

const PruposeDesktop = () => {

    const {t, i18n} = useTranslation();
    const { windowSize } = useContext(GlobalContext);
    
    const [maxWidth, setMaxWidth] = useState('');

    useEffect(()=> {
        setMaxWidth({
            'xxl': '22%'
        }[windowSize] ?? "30%");
    }, [windowSize]);

    return(
        <>
            <Row>
                <Col className='position-relative m-auto d-flex flex-column align-items-end align-items-lg-center' style={{maxWidth: maxWidth}} lg={3}>
                    {i18n.language === "en-US" ?
                        <div className={`mb-2 ${styles.button}`} style={{backgroundColor: "#4B708D"}}>UX</div>
                    :
                        <div className={`mb-2 ${styles.button_spanish}`}>EXPERIENCIA DEL USUARIO (UX)</div>
                    }
                    <Text color="#4B708D" size="17px" align="center">{t("purpose-ux-text")}</Text>
                    <SvgLoader svgProps={{path: "images/icons/line-1.svg", width: "100%", className: "position-absolute", style: {bottom: "-65px"}}} />
                </Col>
            </Row>
            <Row>
                <Col className={`position-relative d-flex flex-column justify-content-center align-items-start ${styles.m_top}`} style={{maxWidth: maxWidth}} lg={3}>
                    <div className={`mb-2 ${styles.button}`} style={{backgroundColor: "#153040"}}>{t("purpose-learn-title")}</div>
                    <Text color="#4B708D" size="17px" align="start">{t("purpose-learn-text")}</Text>
                    <SvgLoader svgProps={{path: "images/icons/line-2.svg", width: "100%", className: "position-absolute", style: {top: "50px", right: "-220px"}}} />
                </Col>
                <Col className="m-auto mt-3" lg={6}>
                    <SvgLoader svgProps={{path: "images/icons/purpose.svg", width: "100%"}} />
                </Col>
                <Col className={`position-relative ${styles.m_top}`} style={{maxWidth: maxWidth}} lg={3}>
                    <div className="d-flex flex-column justify-content-center align-items-end" style={{marginTop: i18n.language === "en-US" ? "2rem" : "1rem"}}>
                        <div className={`mb-2 ${styles.button}`} style={{backgroundColor: "#81AFD9"}}>{t("purpose-culture-title")}</div>
                        <Text color="#4B708D" size="17px" align="end">{t("purpose-culture-text")}</Text>
                        <SvgLoader svgProps={{path: "images/icons/line-3.svg", width: "100%", className: "position-absolute", style: {top: "53px", left: "-210px"}}} />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="position-relative m-auto mt-3 d-flex flex-column align-items-lg-center">
                    <div className={`mb-2 ${styles.change_btn} text-primary`}>{t("purpose-change-title")}</div>
                    <div className={`col-12 col-lg-6 ${styles.change_container}`}>
                        <p>{t("purpose-change-text-1")} <b>{t("purpose-change-text-2")}</b> {t("purpose-change-text-3")}<b> {t("purpose-change-text-4")}</b> {t("purpose-change-text-5")}</p>
                        <SvgLoader svgProps={{path: "images/icons/line-4.svg", width: "100%", className: "position-absolute", style: {top: "-265px", left: "0"}}} />
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default PruposeDesktop;